<template>
  <span>
    <SpinNumber :start="1" :startShow="startShow" :result="Numbers[0]" :sec="0" />
    <SpinNumber :start="3" :startShow="startShow" :result="Numbers[1]" :sec="0" />
    <SpinNumber :start="5" :startShow="startShow" :result="Numbers[2]" :sec="0" />
    <SpinNumber :start="7" :startShow="startShow" :result="Numbers[3]" :sec="0" />
    <SpinNumber :start="9" :startShow="startShow" :result="Numbers[4]" :sec="0" />
  </span>
</template>
<script>
import SpinNumber from './SpinNumber.vue'
export default {
  name: 'SpinNumbers',
  components: {
    SpinNumber
  },
  props: {
    startShow: {
      type: String,
      default: null
    },
    resultNumbers: {
      type: String,
      default: null
    }
  },
  computed: {
    Numbers() {
      if(this.resultNumbers) {
        return this.resultNumbers.split('')
      }else{
        return ['', '', '', '', '']
      }
    }
  }
}
</script>
